import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';
import { planGuard } from './core/guards/plan.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'signup',
    loadComponent: () => import('./features/auth/signup/signup.component').then(c => c.SignupComponent),
    canActivate: [loginGuard]
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(c => c.LoginComponent),
    canActivate: [loginGuard]
  },
  {
    path: 'assinar',
    loadComponent: () => import('./features/assinar/assinar.component').then(c => c.AssinarComponent),
    canActivate: [authGuard]
  },
  {
    path: '',
    loadComponent: () => import('./shared/components/layout/layout.component').then(c => c.LayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(c => c.DashboardComponent),
        canActivate: [planGuard]
      },
      {
        path: 'produtos',
        loadComponent: () => import('./features/produtos/produtos.component').then(c => c.ProdutosComponent),
        canActivate: [planGuard]
      },
      {
        path: 'perfil-publico',
        loadComponent: () => import('./features/perfil-publico/perfil-publico.component').then(c => c.PerfilPublicoComponent),
        canActivate: [planGuard]
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./features/relatorios/relatorios.component').then(c => c.RelatoriosComponent),
        canActivate: [planGuard]
      },
      {
        path: 'promocoes',
        loadComponent: () => import('./features/gestao-promocoes/gestao-promocoes.component').then(c => c.GestaoPromocoesComponent),
        canActivate: [planGuard]
      }
    ]
  }
];
